module.exports = __webpack_public_path__ + "files/82bbc449b09f9259352766866f0db6bf.svg";